module.exports = __webpack_public_path__ + "img/banner-xs.65bbd3be.png";